<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { Sidebar } from '../components/';
import { useStudyStore } from '@/stores/study';
import ProgressSpinner from 'primevue/progressspinner';
import { useRouter, useRoute } from 'vue-router';
import { routeConstants } from '@/utils';

const studyStore = useStudyStore();
const router = useRouter();
const route = useRoute();

const isMobile = ref(window.matchMedia('(max-width: 768px)').matches || history.state.hideSidebar);

onMounted(() => {
  (async () => {
    await studyStore.getStudies();
    if (route.fullPath === '/dash') {
      if (studyStore.selectedStudy?.longitudinal) {
        router.push({
          name: routeConstants.CASES.name
        });
      } else {
        router.push({
          name: routeConstants.ENTRIES.name
        });
        return { name: routeConstants.ENTRIES.name }; 
      }
    }
  })();
});

const showSidebar = computed(() => 
  (!(studyStore.selectedStudy?.flags?.spRedirect && !studyStore.studyPermissions?.manageInvest && !studyStore.studyPermissions?.editCases))
);
</script>

<template>
  <div class="dashboard">
    <div class="drawer" v-if="showSidebar && !isMobile"><Sidebar /></div>
    <div class="container" :class="{ 'spRedirect' : !showSidebar, 'mobile': isMobile}"><RouterView /></div>
  </div>
  <div class="dashboard-progress" v-if="studyStore.studyLoader.isLoading">
    <ProgressSpinner strokeWidth="4" />
  </div>
</template>

<style scoped lang="scss">
.dashboard {
    display: flex;
    width: 100vw;
    height: 100vh;
}
.drawer {
    width: 260px !important;
    height: 100vh;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.container {
    background-color: hsl(0, 0%, 98%);
    height: 100vh;
    width: calc(100% - 260px);
}
.mobile {
  width: 100%;
}
.spRedirect {
  :deep(.entry-root) {
    display: flex;
    justify-content: center;
  }
}
.dashboard-progress {
  display: flex;
  align-items: center;
  height: 100vh;
  width: 100%;
  justify-content: center;
}
</style>
